<template>
<div class="panel">
    <div style="background:#eee;padding: 3px">
        <Card :bordered="false" :padding="5">
            <Row v-show="pageType === 'detail'"  type="flex" justify="start">
                <Toolbar ref="tool" type="horizontal" :config="billHead.toolbar" :fontplacement="billHead.toolbar.fontplacement" @doAction="_actionMethod" btntype="Button" :showBack="true"></Toolbar>
            </Row>
            <Row v-show="pageType === 'list'" :gutter="4"  type="flex" justify="start">
                <Col>
                <!-- <Toolbar ref="tool" type="horizontal" :config="toolbarConfig" :fontplacement="toolbarConfig.fontplacement" @doAction="_actionMethod" btntype="Button" :showBack="true"></Toolbar> -->
                
                    <Button @click="addData"  type="primary" icon="ios-add">新增</Button>
                </Col>
                <Col>
                    <Button @click="deleteHeadBill"  type="primary" icon="ios-close">删除</Button>
                </Col>
                <Col>
                    <Input search enter-button="查询" @on-search="search" v-model="vaule"  placeholder="请输入查询内容" style="width: 300px" />
                </Col>
            </Row>
        </Card>
    </div>  
    <div class="panel" style="background:#eee;padding-left:5px;padding-right:5px;margin-bottom:5px;">
        <Card :bordered="false" :padding="5">
            <Tabs v-model="pageType">
                <TabPane  name="list" icon="md-copy" label="单据列表"  @click="pageToList">
                    <OcmViewGrid v-show="pageType ==='list'"  ref="list" :config="billQueryList"  :dictData="globalConfig.dictData" @dbclick="dbclick"  @doAction="_actionMethod"></OcmViewGrid> 
                </TabPane>
                <TabPane name="detail" icon="md-copy" label="单据明细" @click="pageToDetail">
                    <OcmFormDetail v-show ="pageType ==='detail'" ref="head" :config="billHead"  :dictData="globalConfig.dictData" @doAction="_actionMethod"/>
                    <BillImport ref="billImport" :config="billImportConfig" @importSuccess="importSuccess"> </BillImport>
                </TabPane>    
            </Tabs>
        </Card>
    </div>
</div>    
</template>
<script>
    import Load from '@/components/load/loadcartoon.vue';
    import Base from './layoutbase.vue';
    import toolAnchor from '@/components/form/toolanchor';
    import comPro from '@/components/form/formcompro';
    export default {
        name: 'ocmstandarbill',
        extends: Base,
        mixins: [comPro,toolAnchor],
        components: {
            Load
        },
        data () {
            return {
                showHead:true,
                chooseImport:false,
                pageType:'list',
                downtype:'',
                globalBillQueryList:{
                    showIndex:true,
                    multiSelect: false,
                    height:1,
                    defaultMethod:'search',
                    items:[]
                },
                vaule:'',
                globalBillHead:{
                    lineNum:'4',
                    labelWidth:100,
                    defaultMethod:'get',
                    importKey:'',
                    items:[]
                },
                billQueryList:{},
                toolbar:{},
                billHead:{},
                billDetail:[],
                billImportConfig:{
                    typeData:[]
                },
                basecodelist: [],
                btcodelist: [],
                custtypelist: [],
                toolbarConfig:{
                    fontplacement:'bottom',
                    spacing:4,
                    type:'vertical',
                    rule:{
                        status:{
                            'N':  ['addData','batch'],
                            'Y':  ['addData','batch'],
                            'C':  ['addData','batch']
                        }
                    },
                    items:[{
                        iconcls:'ios-add',
                        name:'addData',
                        type:'primary',
                        text:'新增'
                    }, {
                        iconcls:'ios-close',
                        name:'batch',
                        type:'primary',
                        text:'批量删除'
                    }]
                },
                /* toolbarConfig:{
                    fontplacement:'bottom',
                    spacing:4,
                    rule:{
                        billstatus:{
                            'N':['addData', 'editData', 'delData', 'checkData'],
                            'Y':['addData', 'backSaveMemberActRule']
                        }
                    },
                    status:{
                        'N':[],
                        'S':['addData', 'editData', 'delData', 'checkData'],
                        'Y':['addData', 'backSaveMemberActRule'],
                        'C':[]
                    },
                    showback:true,
                    backbtn:{
                        iconcls:'ios-undo-outline',
                        name:'back',
                        type:'primary',
                        text:'返回'
                    },
                    items:[{
                        iconcls:'ios-add',
                        name:'addData',
                        type:'primary',
                        text:'新增'
                    }, {
                        iconcls:'ios-create-outline',
                        name:'editData',
                        type:'primary',
                        text:'编辑'
                    }, {
                        iconcls:'ios-close',
                        name:'delData',
                        type:'primary',
                        text:'删除'
                    }, {
                        iconcls:'ios-bookmarks-outline',
                        name:'saveData',
                        type:'primary',
                        text:'保存'
                    }, {
                        iconcls:'ios-checkmark',
                        name:'checkData',
                        type:'primary',
                        text:'审核'
                    }, {
                        iconcls:'ios-arrow-round-back',
                        name:'backSaveMemberActRule',
                        type:'primary',
                        text:'取消'
                    }, {
                        iconcls:'batch',
                        name:'batchDelData',
                        text:'删除'
                    }]
                }, */
            };
        },
        created () {
            this.initBillHead();
            this.initBillQueryList();
            this.getBasecodeList();
            this.getCusttypeList();
            this.initDict();
        },
        methods:{
            addDataCommon() {
                this.$refs.head.clearData();
                this.showHead = true;
                this.globalConfig.operflag='I';
                this.$refs.head.setFormReadOnly(false);
                this.$refs.tool.changedStatus('N');
            },
            initBillQueryList() {
                for (let global in this.globalBillQueryList) {
                    if (this.billQueryList[global] === undefined) {
                        this.billQueryList[global] = this.globalBillQueryList[global];
                    }
                }
                let listConfig  = this.getListConfig(this.billQueryList.name);
                for (let tempList in listConfig) {
                    this.billQueryList[tempList] = listConfig[tempList];
                }

                if (this.billQueryList.method === undefined) {
                    this.billQueryList.method = this.methodPrefix + '.' + this.billQueryList.defaultMethod;

                }

                if (this.billQueryList.resources === undefined) {
                    this.billQueryList.resources = this.resources; 
                } else {
                    this.billQueryList.resources = this.OmdUrl[this.billQueryList.resources];
                }

                if (this.billQueryList.response === undefined) {
                    this.billQueryList.response = this.billQueryList.name;
                }
                this._initItem(this.billQueryList.items);
            },
            initBillHead() {
                for (let global in this.globalBillHead) {
                    if (this.billHead[global] === undefined) {
                        this.billHead[global] = this.globalBillHead[global];
                    }
                }

                let headConfig  = this.getHeadConfig(this.billHead.name);
                for (let tempList in headConfig) {
                    this.billHead[tempList] = headConfig[tempList];
                }

                if (this.billHead.method === undefined) {
                    this.billHead.method = this.methodPrefix + '.' + this.billHead.defaultMethod;

                }

                if (this.billHead.resources === undefined) {
                    this.billHead.resources = this.resources; 
                } else {
                    this.billHead.resources = this.OmdUrl[this.billHead.resources];
                }

                if (this.billHead.response === undefined) {
                    this.billHead.response = this.billHead.name;
                }

                if (this.billDetail.length > 0) {
                    this.billHead.detail = [];
                    for (let detail = 0; detail < this.billDetail.length; detail++){
                        this.initBillDetail(this.billDetail[detail]);
                    }
                }
                this._initItem(this.billHead.items);
                this.initToolbar(this.toolbar);
            },
            initBillDetail(obj) {
                let detailConfig  = this.getDetailConfig(obj.name);
                let type ={};
                type.code = this.billImportConfig.typeData.length + 1;
                type.name = detailConfig.title;
                this.billImportConfig.typeData.push(type);
                this._initItem(detailConfig.items);
                if (detailConfig.cellbeginedit) {
                    detailConfig.cellbeginedit = this[detailConfig.cellbeginedit];
                }
                this.billHead.detail.push(detailConfig); 
            },
            initToolbar(obj) {
                this.billHead.toolbar = this.getToolbarConfig(obj.name);
                // this.filterBtnByToken();
            },
            initHead(){
                this.$refs.head.setFormReadOnly(true);
                this.$refs.tool.changedStatus('D');
                this.hideLoading();
            },
            getBasecodeList() {
                let self = this;
                self.synchroPost(this.OmdUrl.member, 'efuture.omc.membership.search', {}, function(response) {
                    self.basecodelist = response.membership_base;
                });
            },
            getBtcodeLevel(baseobj) {
                this.btcodelist = [];
                if(baseobj.name !== undefined){
                    this.$refs.head.setValue('membership_btcode','');
                }
                let self = this;
                self.synchroPost(this.OmdUrl.member, 'efuture.omc.membership.selectMembershipData', {
                    queryparam: baseobj.value
                }, function(response) {
                    if (response) {
                        self.btcodelist = response.result;
                        self.$refs.head.setPro('membership_btcode',{data:self.btcodelist});
                    }
                });
                return true;
            },
            getCusttypeList() {
                let self = this;
                self.synchroPost(self.OmdUrl.work, 'omc.work.custtype.getcusttypewithtags', {}, function(response) {
                    if (response) {
                        self.custtypelist = response.custtype;
                    }
                });
            },
            getTicket(data){
                this.$refs.head.updateRow('bmemberactheadprojects',0,data[0]);
                return true;
            },
            /* setBillData(data) {
                data.bmemberacthead.bmemberactheadprojects=[];
                data.bmemberacthead.bmemberactheadcontacts=[];
                data.bmemberacthead.bmemberactheadgro=[];
                data.bmemberacthead.bmemberactheadmsg=[];
                data.bmemberacthead.billmoduleid='10072';
                data.bmemberacthead.bmemberactdetbeans.forEach(el => {
                    if (el.group_id === '02' || el.group_id === '05') {
                        data.bmemberacthead.bmemberactheadprojects.push(el);
                    } else if (el.group_id === '01') {
                        data.bmemberacthead.bmemberactheadcontacts.push(el);
                    } else if (el.group_id === '04') {
                        data.bmemberacthead.bmemberactheadgro.push(el);
                    } else {
                        data.bmemberacthead.bmemberactheadmsg.push(el);
                    }
                });
                return data;
            }, */
            checkData() {
                let billno=this.$refs.head.getValue('billno');
                this.$Modal.confirm({
                    title: '确定审核吗?',
                    content:`单据编号:[${billno}]会被审核!`,
                    onOk: () => {
                        let self = this;
                        this.$refs.head.setValue('billstatus','Y');
                        self.asyncPost(self.OmdUrl.member, 'efuture.omc.bmemberact.saveMemberActRule', {
                            billno:billno
                        }, function(response) {
                            if(response){
                                self.alert('审核成功!');
                            }
                            
                        });
                    }
                });
            },
            pageToList () {
                this.pageType='list';
                this.$refs.list.refurbish();
            },
            pageToDetail () {
                this.pageType='detail';
            },
            back() {
                if (this.globalConfig.operflag !== 'V') {
                    if (this.$refs.head.isChange()) {
                        let self = this;
                        self.$Modal.confirm({
                            title: '确认',
                            content: '单据有修改未保存，是否放弃修改？',
                            onOk: () => {
                                this.pageType='list';
                                self.showHead = false;
                                self.$refs.list.refurbish();
                            },
                        });
                    } else {
                        this.pageType='list';
                        this.showHead = false;
                        this.$refs.list.refurbish();
                    }
                } else {
                    this.pageType='list';
                    this.showHead = false;
                    this.$refs.list.refurbish();
                }
                
            },
            _setBillData(data){
                if (this.setBillData) {
                    data = this.setBillData(data);
                }
                this.$refs.head.setData(data[this.billHead.name]);
                this.$refs.head.setFormReadOnly(true);
                this.$refs.tool.changedStatus('S');
                this.globalConfig.operflag = 'V';  
                this.hideLoading();
            },

            saveDataSuccess(data) {
                this.refurbish(data[0]);
            },

            delDataSuccess() {
                this.$refs.head.clearData();
                this.$refs.tool.changedStatus('D');
                this.$refs.head.setFormReadOnly(true);
            },

            addData() {
                this.pageType = 'detail';
                this.addDataBefore();
                if (this.globalConfig.operflag === 'U') {
                    if (this.$refs.head.isChange()) {
                        let self = this;
                        self.$Modal.confirm({
                            title: '确认',
                            content: '单据有修改未保存，是否放弃修改？',
                            onOk: () => {
                                self.addDataCommon();
                            }
                        });
                    }
                } else {
                    this.addDataCommon();
                }
                return true;
            },
            editData() {
                this.globalConfig.operflag ='U';
                this.$refs.head.setFormReadOnly(false);
                this.$refs.tool.changedStatus('E');
                return true;
            },

            delData(action) {
                let self = this;
                let flag = true;
                self.$Modal.confirm({
                    title: '确认',
                    content: '确定是否删除单据？',
                    onOk: () => {
                        let method = self.methodPrefix + '.' + self._getActionMethod(action);
                        let form = self.$refs.head.getData();
                        form.flag = 'D';
                        this.globalConfig.operflag='';
                        flag = this.doPost(action,self.billHead.resources,method,form,self.delDataSuccess);
                        this.$refs.list.refurbish();
                        this.pageType = 'list';
                    
                    }
                });
                return flag;
            },
            deleteHeadBill () {
                let data = this.$refs.list.getSelection();
                if (data.length  === 0) {
                    this.alert('请至少选择一行');
                    return;
                }
                let self = this;
                let method = self.methodPrefix + '.save';
                if (data && data.length > 0) {
                    const length = data.length;
                    for (let i=0; i<length; i++) {
                        if (data[i].billstatus === 'C' || data[i].billstatus === 'Y') {
                            this.alert('存在已审核或已取消的单据，请重新选择');
                            return;
                        } else {
                            data[i].flag = 'D';
                        }
                    }
                    self.synchroPost(self.billHead.resources, method , data, function(data){
                        if (data) {
                            self.$refs.list.refurbish();
                        }
                    });
                }
            },
            saveData(action) {
                let method = this.methodPrefix + '.' + this._getActionMethod(action);
                this.$refs.head.checkValidate();
                if (this.$refs.head.isError()) {
                    return;
                }
                let form = this.$refs.head.getChangeData();
                form.flag = this.globalConfig.operflag;
                if (this.getCustomChangeData) {
                    form = this.getCustomChangeData(form);
                }
                return this.doPost(action,this.billHead.resources,method,form,this.saveDataSuccess);
            },
        },

        mounted (){
            let self = this;
            self.showLoading();
            self.$nextTick(() => {
                setTimeout(() => {
                    self.$refs.list.refurbish();
                    self.hideLoading();
                }, 500);
            });
            
        }
    };
</script>
<style>
 .panel .ivu-table {
     font-size: 12px;
 }
 .ivu-table {
     font-size: 12px;
 }
</style>


// WEBPACK FOOTER //
// src/components/layout/ocmstandardbill.vue